// libs
import { styled } from '@nykaa/ui-components';
import { css } from '@emotion/core';

// components
import BaseRippleIt from 'shared/components/RippleIt';

export const Container = styled(BaseRippleIt) <{ containerWidth: number; }>`
  width: ${(props) => props.containerWidth}px;
  flex: none;
  padding: ${({ theme }) => theme.spacing.spacing60} 0;
  margin-right: ${({ theme }) => theme.spacing.spacing40};
`;

export const ImageContainer = styled.div<{
  shouldAnimate: boolean;
  animationDuration: number;
  animationDelay: number;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 0px;
  height: 0px;

  ${(props) =>
    props.shouldAnimate &&
    css`
      transition: width ${props.animationDuration}ms ease-in ${props.animationDelay}ms;
      width: 24px;
      height: 24px;
    `}
`;

export const TagWrapper = styled.div`
  height: 40px;
  width: 40px;
  background-color: ${({ theme }) => theme.colors.responsibleTagBg};
  border-radius: ${({ theme }) => theme.borders.radiusFull};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Text = styled.p`
  ${({ theme }) => theme.typography.bodySmall};
  margin: 0;
  margin-top: ${({ theme }) => theme.spacing.spacing40};
  color: ${({ theme }) => theme.colors.textPrimary};
`;
